import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';

export interface IInputTextComponentConfiguration extends IInputComponentConfiguration<
	string,
	string
> {
	debouncerDelay?: number | null;
	type?: 'text' | 'password' | 'email';
};

export class InputTextComponent extends InputComponent<
	HTMLInputElement,
	string,
	string,
	InputTextComponent,
	IInputTextComponentConfiguration
> {
	component_DOM: HTMLInputElement;

	override deserialize(x: string) {
		return (x);
	};

	async onTextUpdated() {
		const newValue = this.component_DOM.value;
		await this.updateValue(newValue);
	};

	override isValueTheDefault() {
		return (this.value === this.defaultValue);
	};

	private onValueUpdated(ev: STD.events.Event<any, CM.Component<any, any>>) {
		this.component_DOM.value = ev.details.newValue;
	};

	async reset() {
		await this.updateValue(this.component_configuration.defaultValue || null);
	};

	serialize() {
		return this.value;
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IInputTextComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLInputElement>STD.DOM.factory({
			tag: 'input',
			attributes: {type: this.component_configuration.type || 'text'},
			classList: ['text-title-writable'],
			events: {
				input: (
					this.component_configuration.debouncerDelay ? STD.misc.createDebouncer({
							fn: <() => void><any>this.onTextUpdated.bind(this),
							delay: this.component_configuration.debouncerDelay
						}) :
						this.onTextUpdated.bind(this)
				)
			}
		});

		if (this.component_hasTranslation('placeholder')) {
			this.component_DOM.dataset.translationAttr = 'placeholder:' + this.component_getTranslationId('placeholder');
		}

		this.addEventListener('value', this.onValueUpdated.bind(this), {
			subType: 'input-text',
			listener: this
		});
	};
};
export namespace NS {
	export const Component = InputTextComponent;
	export type Component = InputTextComponent;
	export type Configuration = IInputTextComponentConfiguration;
}
import {InputComponent, IInputComponentConfiguration} from '../Input/Input';
import './InputText.scss';

CM.Manager.declare({
	id: 'input-text',
	type: InputTextComponent
});
